import * as React from "react";
import { Lazyloader } from "../Lazyloader/Lazyloader";
import { Icon } from "../Icon/icon";
export interface CurrentEventProps {
  url: string;
  imageUrl: string;
  headline: string;
  date?: string;
  timeDateFormat?: string;
  text: string;
  lowresBase64?: string;
  isInEditMode?: boolean;
  externalImage?: string;
  cssClassArticle?: string;
  cssClassText?: string;
  cssClassHeading?: string;
  Id?: number;
  ImageDescription?: string;
  useH2Heading?: boolean;
}

export const CurrentEvent: React.SFC<CurrentEventProps> = (props) => (
  <article
    key={props.Id}
    className={`current-event ${
      props.cssClassArticle != null ? props.cssClassArticle : ""
    }`}
  >
    <a href={props.url}>
      {props.imageUrl !== null ? (
        <Lazyloader
          imageUrl={props.imageUrl}
          lowresBase64={props.lowresBase64}
          imageAltText={props.ImageDescription}
        />
      ) : props.externalImage !== null ? (
        <div className="external-image-wrapper">
          <img alt="" src={props.externalImage} />
        </div>
      ) : null}

      {props.date && (
        <time
          className="text-micro"
          dateTime={
            props.timeDateFormat != null ? props.timeDateFormat : props.date
          }
        >
          {props.date}
        </time>
      )}
      {props.useH2Heading ? (
        <h2 className={`heading-small ${props.cssClassHeading}`}>
          {props.headline}
          <Icon className="" iconType="fontawesome/chevron-left" />
        </h2>
      ) : (
        <h3 className={props.cssClassHeading}>
          {props.headline}
          <Icon className="" iconType="fontawesome/chevron-left" />
        </h3>
      )}
      {props.text != null && props.text != "" ? (
        <p className={props.cssClassText}>{props.text}</p>
      ) : null}
    </a>
  </article>
);
